import {isEmpty} from 'lodash';
import jwt_decode from "jwt-decode";
import SetGAConfig from "./SetGAConfig";
import AxiosInstance from "../api/instance";

const addSessionToken = (token: string) => {
    sessionStorage.setItem('genToken', token);
};

const addRefreshToken = (refreshToken: string) => {
    sessionStorage.setItem('genRefToken', refreshToken);
};

const getRefreshToken = () => {
    return sessionStorage.getItem('genRefToken');
};

const setCurrentUser = (userData: string) => {
    sessionStorage.setItem('genUser', userData);
};

const getCurrentUser = () => {
    return sessionStorage.getItem('genToken');
};

const isLoggedIn = (): boolean => {
    return !isEmpty(sessionStorage.getItem('genToken'));
};

const logOutUser = () => {
    sessionStorage.removeItem('genToken');
    clearRememberMeCookies();
};

const getAuthorizationHeaders = () => {
    const token = sessionStorage.getItem('genToken');
    let tkn: string | null = null
    if (token !== undefined) {
        tkn = token;
    }

    return {
        headers: {
            "X-Auth-Token": tkn
        }
    };
};

const REMEMBER_ME_SERIAL_ID = 'identifier';
const REMEMBER_ME_TOKEN = 'token';
const REMEMBER_ME_FOR_DAYS = 7;

const setRememberMeCookie = (name: string, value: string) => {
    const maxAge = REMEMBER_ME_FOR_DAYS * 24 * 60 * 60;
    document.cookie = name + "=" + encodeURIComponent(value) + ";path=/;max-age=" + maxAge;
};

const getRememberMeCookie = (name: string) => {
    const cookies = document.cookie.split(";").filter((c) => c.trim().startsWith(name + '='));
    if (cookies.length) {
        const cookie = decodeURIComponent(cookies[0].split(name + '=')[1]);
        if (cookie) {
            return cookie;
        }
    }
    return "";
};

const setRememberMeCookies = (serialId: string, token: string) => {
    setRememberMeCookie(REMEMBER_ME_SERIAL_ID, serialId);
    setRememberMeCookie(REMEMBER_ME_TOKEN, token);
};

const getRememberMeCookies = () => {
    const serialId = getRememberMeCookie(REMEMBER_ME_SERIAL_ID);
    const token = getRememberMeCookie(REMEMBER_ME_TOKEN);
    if (serialId && token) {
        return {
            [REMEMBER_ME_SERIAL_ID]: serialId,
            [REMEMBER_ME_TOKEN]: token
        };
    }
    return null;
};

const clearRememberMeCookies = () => {
    document.cookie = REMEMBER_ME_SERIAL_ID + "=;path=/;max-age=0;";
    document.cookie = REMEMBER_ME_TOKEN + "=;path=/;max-age=0;";
};

const returnValidResponse = (response: any) => {
    if (response && response.data) {
        return response.data;
    }
};

const setGAUserConfig = (token: string) => {
    try {
        const decoded: any = jwt_decode(token);
        if (decoded) {
            SetGAConfig(decoded.user_id);
        }
    } catch (e) {
        /* tslint:disable:no-empty */
    }
};

const getUserData = async () => {
    const response = await AxiosInstance.getInstance().get("/user").catch(():any => {
        return null;
    });

    return returnValidResponse(response);
};

const saveUserData = async (fisrtName: string, lastName: string) => {
    const response = await AxiosInstance.getInstance().post("/user", {
        first_name: fisrtName,
        last_name: lastName
    }).catch(():any => {
        return null;
    });

    return returnValidResponse(response);
};

const uploadProfilePicture = async (formData: any) => {
    await AxiosInstance.getInstance().post("/user/upload-profile-picture", formData).catch(():any => {
        return null;
    });

    return "OK";
};

const sendPasswordVerificationEmail = async () => {
    await AxiosInstance.getInstance().post("/user/send-password-verification").catch(():any => {
        return null;
    });

    return "OK";
};

const changePassword = async (code: string, password: string) => {
    const response = await AxiosInstance.getInstance().post("/user/change-password", {
        code,
        password
    }).catch(():any => {
        return null;
    });

    return response;
};

const getAPIKeys = async () => {
    const response = await AxiosInstance.getInstance().get("/api-key/list").catch(():any => {
        return null;
    });
    return returnValidResponse(response);
};

const createAPIKey = async (name: string) => {
    const response = await AxiosInstance.getInstance().post("/api-key", { name });
    return returnValidResponse(response);
};

const editAPIKey = async (id: number, name: string) => {
    const response = await AxiosInstance.getInstance().put("/api-key", {
        id,
        new_name: name
    });
    return returnValidResponse(response);
};

const deleteAPIKey = async (id: number) => {
    const response = await AxiosInstance.getInstance().delete("/api-key", {
        params: {id}
    });
    return response;
};

export {
    getCurrentUser,
    addSessionToken,
    addRefreshToken,
    getRefreshToken,
    setCurrentUser,
    isLoggedIn,
    logOutUser,
    getAuthorizationHeaders,
    setRememberMeCookies,
    getRememberMeCookies,
    clearRememberMeCookies,
    REMEMBER_ME_SERIAL_ID,
    REMEMBER_ME_TOKEN,
    setGAUserConfig,
    getUserData,
    saveUserData,
    uploadProfilePicture,
    sendPasswordVerificationEmail,
    changePassword,
    getAPIKeys,
    createAPIKey,
    editAPIKey,
    deleteAPIKey
};


// WEBPACK FOOTER //
// ./src/utils/auth.ts